import { render, staticRenderFns } from "./basicReport.vue?vue&type=template&id=222f458a&scoped=true&"
import script from "./basicReport.vue?vue&type=script&lang=js&"
export * from "./basicReport.vue?vue&type=script&lang=js&"
import style0 from "./basicReport.vue?vue&type=style&index=0&id=222f458a&prod&scoped=true&lang=css&"
import style1 from "./basicReport.vue?vue&type=style&index=1&id=222f458a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222f458a",
  null
  
)

export default component.exports